import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';
import {startRecordFeatureKey, State} from '../reducers/start-record.reducer';

export const selectStartRecordState =
  createFeatureSelector<State>(startRecordFeatureKey);

export const getStartRecord = createSelector(
  selectStartRecordState,
  (state: State): DvrRecord | null => state.record
);

export const getStartRecordLoaded = createSelector(
  selectStartRecordState,
  (state: State): boolean => state.loaded
);

export const getStartRecordLoading = createSelector(
  selectStartRecordState,
  (state: State): boolean => state.loading
);

export const getStartRecordError = createSelector(
  selectStartRecordState,
  (state: State): unknown => state.error
);
